import { tabToName } from "@utils/utils";
import { useEffect } from "react";

import { Button, TabNavigation } from "@fronterahealth/frontera-ui-components";

import { useAdminData } from "@providers/AdminDataProvider";
import { VideoAnalyticsTabType, useVideoAnalytics } from "@providers/VideoAnalyticsProvider";

export const AnalyticsTab = () => {
  const { selectedAnalyticTab, setSelectedAnalyticTab } = useVideoAnalytics();
  const { isUserBCBA } = useAdminData();

  const videoAnalyticsNavigationTabs: VideoAnalyticsTabType[] = isUserBCBA ? ["My Metrics", "RBTs"] : ["BCBAs", "RBTs"]; // ["Overview", "BCBAs", "RBTs"] will update soon

  useEffect(() => {
    if (isUserBCBA) {
      setSelectedAnalyticTab("My Metrics");
    } else {
      setSelectedAnalyticTab("BCBAs");
    }
  }, [isUserBCBA]);
  return (
    <div className={`min-w-full  no-scrollbar overflow-x-scroll border-gray-200`}>
      <TabNavigation
        edgeToEdge
        tabs={videoAnalyticsNavigationTabs.map((tab) => ({
          current: selectedAnalyticTab === tab,
          type: "component",
          name: tab,
          Component: (
            <Button
              text={<div className="w-full flex font-normal flex-row justify-center gap-2">{tabToName(tab)}</div>}
              appearance="text"
              className={`hover:text-primary ${selectedAnalyticTab === tab ? "text-limestone-900" : "text-text-secondary"}`}
              onClick={() => setSelectedAnalyticTab(tab)}
            />
          ),
        }))}
      />
    </div>
  );
};
